KlaviyoSubscribe.attachToForms('#email_signup_popup_X4e4f5', {
    hide_form_on_success: true,
    extra_fields: ["$phone_number"]
});

function getCookie(name) {
    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

let emailPopup = document.querySelector(".js-email-popup");

document.addEventListener('click', function(e){
    if(e.target.matches('.js-email-popup .close-btn')){
        emailPopup.style.display = 'none';
        sessionStorage.setItem('emailPopup', 'close');
    }
});

var waitForAgeConfirmation = function(callback) {
    if (getCookie("ageConfirmation") === 'confirmed') {
        callback();
    } else {
        setTimeout(function() {
            waitForAgeConfirmation(callback);
        }, 100);
    }
};

// waitForAgeConfirmation(function (){
//     if (sessionStorage.getItem('emailPopup') !== 'close') {
//         setTimeout(function() {
//             emailPopup.style.display = 'flex';
//         }, 5000);
//     }
// });
var waitForCountryDetect = function(callback) {
    if (window.sessionStorage.getItem('country') !== null) {
        callback();
    } else {
        setTimeout(function() {
            waitForCountryDetect(callback);
        }, 100);
    }
};

//Set user country to the session storage.
let country = window.sessionStorage.getItem('country');
if (country === null || country === "") {
    fetch('https://api.ipify.org?format=jsonp&callback=?')
        .then(function(res) {
            return res.text();
        })
        .then(function(text) {
            var json = JSON.parse(text.slice(2, -2));
            fetch('https://ipapi.co/' + json.ip + '/json')
                .then(function(res) {
                    if (!res.ok) {
                        fetch("https://api.geoapify.com/v1/ipinfo?apiKey=b331dab1355b47b4a9e9b5bc759e24e6")
                            .then(response => response.json())
                            .then(function(result) {
                                    if (result.country.name && result.country.name !== '') {
                                        window.sessionStorage.setItem('country', result.country.name);
                                    } else {
                                        window.sessionStorage.setItem('country', 'United States');
                                        country = window.sessionStorage.getItem('country');
                                    }
                                }
                            )
                            .catch(error => console.log('error', error));
                    } else {
                        return res.json();
                    }
                })
                .then(function(data) {

                    if (data.country_name && data.country_name !=='') {
                        window.sessionStorage.setItem('country', data.country_name);
                    } else {
                        if (country === null || country === "") {
                            fetch("https://api.geoapify.com/v1/ipinfo?apiKey=b331dab1355b47b4a9e9b5bc759e24e6")
                                .then(response => response.json())
                                .then(function(result) {
                                        if (result.country.name && result.country.name !== '') {
                                            window.sessionStorage.setItem('country', result.country.name);
                                        } else {
                                            window.sessionStorage.setItem('country', 'United States');
                                            country = window.sessionStorage.getItem('country');
                                        }
                                    }
                                )
                                .catch(error => console.log('error', error));
                        }
                    }
                })
        });
}

waitForAgeConfirmation(function (){
    waitForCountryDetect(function(){
        setTimeout(function() {
            let country = window.sessionStorage.getItem('country');

            if ( country === "United States" || country === "Canada") {
                if ( country === "Canada" ) {
                    document.querySelector('.country-select.canada').style.display = 'flex';
                } else {
                    document.querySelector('.email-popup--info').style.display = 'flex';
                }
            } else {
                document.querySelector('.country-select .country').innerHTML = country;
                document.querySelector('.country-select.eu').style.display = 'flex';
            }
            if (sessionStorage.getItem('emailPopup') !== 'close') {
                emailPopup.style.display = 'flex';
            }

        }, 1000);

    });
});


 function telephoneCheck(str) {
     var isphone = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(str);
     return isphone;
 }

let form = document.getElementById('email_signup_popup_X4e4f5');
var phoneNumber, email;
 document.addEventListener('click', function(e){
     if(e.target.matches('#email_signup_popup_X4e4f5 .klaviyo_submit_button')){
         e.preventDefault();
         phoneNumber = document.querySelector('#email_signup_popup_X4e4f5 .phone-number').value;
         if(!telephoneCheck(phoneNumber)){
             document.querySelector('#email_signup_popup_X4e4f5 .klaviyo_messages .error_message').innerText = 'Incorrect phone number format';
             document.querySelector('#email_signup_popup_X4e4f5 .klaviyo_messages .error_message').style.display = 'block';
         } else {
             document.querySelector('#email_signup_popup_X4e4f5 .klaviyo_messages .error_message').style.display = 'none';
             form.requestSubmit();
         }
     }
 });

let continueBtn = document.querySelectorAll('.cta.continue');
continueBtn.forEach(function (el) {
    el.addEventListener('click', function (){
        document.querySelector('.country-select.eu').style.display = 'none';
        document.querySelector('.country-select.canada').style.display = 'none';
        document.querySelector('.age-modal--outer.js-email-popup').style.display = 'none'
        sessionStorage.setItem('emailPopup', 'close');
    })
})


KlaviyoSubscribe.log = function() {
    if (arguments[0]==='$source') {
        sessionStorage.setItem('emailPopup', 'close');
        let fieldsToHide = document.querySelectorAll('.field-for-hide');
        fieldsToHide.forEach((el) => {
            el.style.display = 'none';
        });
        let messages = document.querySelector('.js-email-popup .klaviyo_messages');
        messages.classList.add('success');
        country = document.querySelector('#email_signup_popup_X4e4f5 .country').value;
        email = document.querySelector('#email_signup_popup_X4e4f5 .email').value;

        if (phoneNumber !== '' && phoneNumber !== undefined) {

            var nameCountries = {
                'Afghanistan' : 'AF',
                'Aland Islands' : 'AX',
                'Albania' : 'AL',
                'Algeria' : 'DZ',
                'American Samoa' : 'AS',
                'Andorra' : 'AD',
                'Angola' : 'AO',
                'Anguilla' : 'AI',
                'Antarctica' : 'AQ',
                'Antigua And Barbuda' : 'AG',
                'Argentina' : 'AR',
                'Armenia' : 'AM',
                'Aruba' : 'AW',
                'Australia' : 'AU',
                'Austria' : 'AT',
                'Azerbaijan' : 'AZ',
                'Bahamas' : 'BS',
                'Bahrain' : 'BH',
                'Bangladesh' : 'BD',
                'Barbados' : 'BB',
                'Belarus' : 'BY',
                'Belgium' : 'BE',
                'Belize' : 'BZ',
                'Benin' : 'BJ',
                'Bermuda' : 'BM',
                'Bhutan' : 'BT',
                'Bolivia' : 'BO',
                'Bosnia And Herzegovina' : 'BA',
                'Botswana' : 'BW',
                'Bouvet Island' : 'BV',
                'Brazil' : 'BR',
                'British Indian Ocean Territory' : 'IO',
                'Brunei Darussalam' : 'BN',
                'Bulgaria' : 'BG',
                'Burkina Faso' : 'BF',
                'Burundi' : 'BI',
                'Cambodia' : 'KH',
                'Cameroon' : 'CM',
                'Canada' : 'CA',
                'Cape Verde' : 'CV',
                'Cayman Islands' : 'KY',
                'Central African Republic' : 'CF',
                'Chad' : 'TD',
                'Chile' : 'CL',
                'China' : 'CN',
                'Christmas Island' : 'CX',
                'Cocos (Keeling) Islands' : 'CC',
                'Colombia' : 'CO',
                'Comoros' : 'KM',
                'Congo' : 'CG',
                'Congo, Democratic Republic' : 'CD',
                'Cook Islands' : 'CK',
                'Costa Rica' : 'CR',
                'Cote D\'Ivoire' : 'CI',
                'Croatia' : 'HR',
                'Cuba' : 'CU',
                'Cyprus' : 'CY',
                'Czech Republic' : 'CZ',
                'Denmark' : 'DK',
                'Djibouti' : 'DJ',
                'Dominica' : 'DM',
                'Dominican Republic' : 'DO',
                'Ecuador' : 'EC',
                'Egypt' : 'EG',
                'El Salvador' : 'SV',
                'Equatorial Guinea' : 'GQ',
                'Eritrea' : 'ER',
                'Estonia' : 'EE',
                'Ethiopia' : 'ET',
                'Falkland Islands (Malvinas)' : 'FK',
                'Faroe Islands' : 'FO',
                'Fiji' : 'FJ',
                'Finland' : 'FI',
                'France' : 'FR',
                'French Guiana' : 'GF',
                'French Polynesia' : 'PF',
                'French Southern Territories' : 'TF',
                'Gabon' : 'GA',
                'Gambia' : 'GM',
                'Georgia' : 'GE',
                'Germany' : 'DE',
                'Ghana' : 'GH',
                'Gibraltar' : 'GI',
                'Greece' : 'GR',
                'Greenland' : 'GL',
                'Grenada' : 'GD',
                'Guadeloupe' : 'GP',
                'Guam' : 'GU',
                'Guatemala' : 'GT',
                'Guernsey' : 'GG',
                'Guinea' : 'GN',
                'Guinea-Bissau' : 'GW',
                'Guyana' : 'GY',
                'Haiti' : 'HT',
                'Heard Island & Mcdonald Islands' : 'HM',
                'Holy See (Vatican City State)' : 'VA',
                'Honduras' : 'HN',
                'Hong Kong' : 'HK',
                'Hungary' : 'HU',
                'Iceland' : 'IS',
                'India' : 'IN',
                'Indonesia' : 'ID',
                'Iran, Islamic Republic Of' : 'IR',
                'Iraq' : 'IQ',
                'Ireland' : 'IE',
                'Isle Of Man' : 'IM',
                'Israel' : 'IL',
                'Italy' : 'IT',
                'Jamaica' : 'JM',
                'Japan' : 'JP',
                'Jersey' : 'JE',
                'Jordan' : 'JO',
                'Kazakhstan' : 'KZ',
                'Kenya' : 'KE',
                'Kiribati' : 'KI',
                'Korea' : 'KR',
                'Kuwait' : 'KW',
                'Kyrgyzstan' : 'KG',
                'Lao People\'s Democratic Republic' : 'LA',
                'Latvia' : 'LV',
                'Lebanon' : 'LB',
                'Lesotho' : 'LS',
                'Liberia' : 'LR',
                'Libyan Arab Jamahiriya' : 'LY',
                'Liechtenstein' : 'LI',
                'Lithuania' : 'LT',
                'Luxembourg' : 'LU',
                'Macao' : 'MO',
                'Macedonia' : 'MK',
                'Madagascar' : 'MG',
                'Malawi' : 'MW',
                'Malaysia' : 'MY',
                'Maldives' : 'MV',
                'Mali' : 'ML',
                'Malta' : 'MT',
                'Marshall Islands' : 'MH',
                'Martinique' : 'MQ',
                'Mauritania' : 'MR',
                'Mauritius' : 'MU',
                'Mayotte' : 'YT',
                'Mexico' : 'MX',
                'Micronesia, Federated States Of' : 'FM',
                'Moldova' : 'MD',
                'Monaco' : 'MC',
                'Mongolia' : 'MN',
                'Montenegro' : 'ME',
                'Montserrat' : 'MS',
                'Morocco' : 'MA',
                'Mozambique' : 'MZ',
                'Myanmar' : 'MM',
                'Namibia' : 'NA',
                'Nauru' : 'NR',
                'Nepal' : 'NP',
                'Netherlands' : 'NL',
                'Netherlands Antilles' : 'AN',
                'New Caledonia' : 'NC',
                'New Zealand' : 'NZ',
                'Nicaragua' : 'NI',
                'Niger' : 'NE',
                'Nigeria' : 'NG',
                'Niue' : 'NU',
                'Norfolk Island' : 'NF',
                'Northern Mariana Islands' : 'MP',
                'Norway' : 'NO',
                'Oman' : 'OM',
                'Pakistan' : 'PK',
                'Palau' : 'PW',
                'Palestinian Territory, Occupied' : 'PS',
                'Panama' : 'PA',
                'Papua New Guinea' : 'PG',
                'Paraguay' : 'PY',
                'Peru' : 'PE',
                'Philippines' : 'PH',
                'Pitcairn' : 'PN',
                'Poland' : 'PL',
                'Portugal' : 'PT',
                'Puerto Rico' : 'PR',
                'Qatar' : 'QA',
                'Reunion' : 'RE',
                'Romania' : 'RO',
                'Russian Federation' : 'RU',
                'Rwanda' : 'RW',
                'Saint Barthelemy' : 'BL',
                'Saint Helena' : 'SH',
                'Saint Kitts And Nevis' : 'KN',
                'Saint Lucia' : 'LC',
                'Saint Martin' : 'MF',
                'Saint Pierre And Miquelon' : 'PM',
                'Saint Vincent And Grenadines' : 'VC',
                'Samoa' : 'WS',
                'San Marino' : 'SM',
                'Sao Tome And Principe' : 'ST',
                'Saudi Arabia' : 'SA',
                'Senegal' : 'SN',
                'Serbia' : 'RS',
                'Seychelles' : 'SC',
                'Sierra Leone' : 'SL',
                'Singapore' : 'SG',
                'Slovakia' : 'SK',
                'Slovenia' : 'SI',
                'Solomon Islands' : 'SB',
                'Somalia' : 'SO',
                'South Africa' : 'ZA',
                'South Georgia And Sandwich Isl.' : 'GS',
                'Spain' : 'ES',
                'Sri Lanka' : 'LK',
                'Sudan' : 'SD',
                'Suriname' : 'SR',
                'Svalbard And Jan Mayen' : 'SJ',
                'Swaziland' : 'SZ',
                'Sweden' : 'SE',
                'Switzerland' : 'CH',
                'Syrian Arab Republic' : 'SY',
                'Taiwan' : 'TW',
                'Tajikistan' : 'TJ',
                'Tanzania' : 'TZ',
                'Thailand' : 'TH',
                'Timor-Leste' : 'TL',
                'Togo' : 'TG',
                'Tokelau' : 'TK',
                'Tonga' : 'TO',
                'Trinidad And Tobago' : 'TT',
                'Tunisia' : 'TN',
                'Turkey' : 'TR',
                'Turkmenistan' : 'TM',
                'Turks And Caicos Islands' : 'TC',
                'Tuvalu' : 'TV',
                'Uganda' : 'UG',
                'Ukraine' : 'UA',
                'United Arab Emirates' : 'AE',
                'United Kingdom' : 'GB',
                'United States' : 'US',
                'United States Outlying Islands' : 'UM',
                'Uruguay' : 'UY',
                'Uzbekistan' : 'UZ',
                'Vanuatu' : 'VU',
                'Venezuela' : 'VE',
                'Viet Nam' : 'VN',
                'Virgin Islands, British' : 'VG',
                'Virgin Islands, U.S.' : 'VI',
                'Wallis And Futuna' : 'WF',
                'Western Sahara' : 'EH',
                'Yemen' : 'YE',
                'Zambia' : 'ZM',
                'Zimbabwe' : 'ZW'
            }
            let countryCode = ''
            Object.entries(nameCountries).forEach(entry => {
                if (entry[0] === country) {
                    countryCode =  entry[1];
                }
            })

            fetch('https://api.smsbump.com/v2/formsPublic/subscribe', {
                method: 'POST',
                body: JSON.stringify({
                    'form_id': 70520,
                    'phone': phoneNumber,
                    'email': email,
                    'country': countryCode,
                    'accepts_sms_marketing': true,
                    'accepts_email_marketing': true,
                    'resubscribe_confirm': true
                }),
                headers: {
                    'Content-Type' : 'application/json',
                    'x-smsbump-platform': 'shopify',
                }
            })
                .then(response => {
                    return response.json().then((data) => {
                        return data;
                    })
                })
                .then(data => {
                })
                .catch(err => {
                console.log('caught it!',err);
            });
        }
    }
}
